export const SelectionModalCustomStyle = {
  content: {
    maxWidth: '580px',
    minHeight: '260px',
  },
};

export const ExtendedSelectionModalCustomStyle = {
  content: {
    maxWidth: '580px',
    minHeight: '378px',
  },
};
